// Shared constants + pure formatting helpers for the Suppliers module.
export const STATUS_STYLE = {
  active: "bg-[#E7F3EA] text-[#1F5B2E] border border-[#BFDCC7]",
  inactive: "bg-[#F0E9E9] text-[#5A4A4A] border border-[#DDD0D0]",
};
export const EMPTY_ADDR = { line1: "", line2: "", city: "", state: "", pincode: "" };
export const EMPTY_FORM = { name: "", company_name: "", gstin: "", phone: "", email: "", address: EMPTY_ADDR, opening_balance: 0, credit_limit: 0, payment_terms_days: 30, notes: "" };

export const grams = (g) => `${(Number(g) || 0).toFixed(3)} g`;
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const goldBalanceClass = (v) => {
  if (v > 0.0005) return "text-[#7A1F1F]";
  if (v < -0.0005) return "text-[#1F5B2E]";
  return "text-muted-foreground";
};
export const inrBalanceClass = (v) => {
  if (v > 0.5) return "text-[#7A1F1F]";
  if (v < -0.5) return "text-[#1F5B2E]";
  return "text-muted-foreground";
};
